































import KamigameVue from '@/KamigameVue';
import ButtonBulkReplaceImageUrl from '@/components/Button/ButtonBulkReplaceImageUrl.vue';
import ButtonBulkPublishDrafts from '@/components/Button/ButtonBulkPublishDrafts.vue';
import ButtonBulkReplaceContentHeader from '@/components/Button/ButtonBulkReplaceContentHeader.vue';
import ButtonBulkTransferArticles from '@/components/Button/ButtonBulkTransferArticles.vue';
import ButtonDownloadCsvForDeferenceFromSource from '@/components/Button/ButtonDownloadCsvForDeferenceFromSource.vue';
import Component from 'vue-class-component';

@Component({
  name: 'set-up-global-wiki',
  components: {
    ButtonBulkReplaceImageUrl,
    ButtonBulkPublishDrafts,
    ButtonBulkReplaceContentHeader,
    ButtonBulkTransferArticles,
    ButtonDownloadCsvForDeferenceFromSource,
  },
})
export default class SetUpGameVillage extends KamigameVue {}
